// The three-step progress indicator, and the scrolling that goes with it.
//
// Each step is three elements that have to change together - the circle, the
// number inside it and the caption beneath - so the class lists live here in
// one place rather than being spelled out at every call site.
(function (global) {
  "use strict";

  const LAST_STEP = 3;
  const MOBILE_BREAKPOINT = 768; // matches Tailwind's md:

  const STYLES = {
    circle: {
      active: "bg-primary border-primary",
      idle: "bg-surface border-border-strong",
    },
    number: { active: "text-white", idle: "text-text-subtle" },
    caption: { active: "text-primary", idle: "text-text-subtle" },
  };

  const circle = (step) => global.$("#circle-" + step);
  const number = (step) => global.$("#circle-text-" + step);
  const caption = (step) => global.$("#step-text-" + step);

  function activateStep(step) {
    circle(step).removeClass(STYLES.circle.idle).addClass(STYLES.circle.active);
    number(step).removeClass(STYLES.number.idle).addClass(STYLES.number.active);
    caption(step).removeClass(STYLES.caption.idle).addClass(STYLES.caption.active);
  }

  function deactivateStep(step) {
    circle(step).removeClass(STYLES.circle.active).addClass(STYLES.circle.idle);
    number(step).removeClass(STYLES.number.active).addClass(STYLES.number.idle);
    caption(step).removeClass(STYLES.caption.active).addClass(STYLES.caption.idle);

    // The line leading into this step is no longer travelled.
    if (step > 1) {
      global.$("#border-" + (step - 1)).removeClass("completed");
    }
  }

  function completeStep(step) {
    number(step).html('<i class="fas fa-check"></i>');
    circle(step)
      .removeClass(STYLES.circle.idle)
      .addClass(STYLES.circle.active);
    number(step).removeClass(STYLES.number.idle).addClass(STYLES.number.active);
    caption(step).removeClass(STYLES.caption.idle).addClass(STYLES.caption.active);

    // Animate the line out of the step just completed.
    if (step < LAST_STEP) {
      global.$("#border-" + step).addClass("completed");
    }
  }

  // Restore the number a completed step replaced with a tick.
  function resetStepNumber(step) {
    number(step).text(String(step));
  }

  function onMobile() {
    return global.innerWidth < MOBILE_BREAKPOINT;
  }

  function scrollToStepper() {
    if (!onMobile()) return;
    const stepper = global.document.getElementById("stepper-container");
    if (stepper) stepper.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function scrollToPageTop() {
    if (!onMobile()) return;
    global.scrollTo({ top: 0, behavior: "auto" });
  }

  const api = {
    activateStep,
    deactivateStep,
    completeStep,
    resetStepNumber,
    scrollToStepper,
    scrollToPageTop,
  };
  if (typeof module !== "undefined" && module.exports) {
    module.exports = api;
  }
  Object.assign(global, api);
})(typeof window !== "undefined" ? window : globalThis);
